import CommonsActions from '../../commons/application/actions/CommonsActions';
import InterpreterActions from '../../commons/application/actions/InterpreterActions';
import SessionActions from '../../commons/application/actions/SessionActions';
import CollabEditingActions from '../../commons/collabEditing/CollabEditingActions';
import * as FileSystemActions from '../../commons/fileSystem/FileSystemActions';
import SideContentActions from '../../commons/sideContent/SideContentActions';
import WorkspaceActions from '../../commons/workspace/WorkspaceActions';
import AcademyActions from '../../features/academy/AcademyActions';
import AchievementActions from '../../features/achievement/AchievementActions';
import DashboardActions from '../../features/dashboard/DashboardActions';
import LanguageDirectoryActions from '../../features/directory/LanguageDirectoryActions';
import PluginDirectoryActions from '../../features/directory/PluginDirectoryActions';
import GitHubActions from '../../features/github/GitHubActions';
import GroundControlActions from '../../features/groundControl/GroundControlActions';
import LeaderboardActions from '../../features/leaderboard/LeaderboardActions';
import PersistenceActions from '../../features/persistence/PersistenceActions';
import PlaygroundActions from '../../features/playground/PlaygroundActions';
import RemoteExecutionActions from '../../features/remoteExecution/RemoteExecutionActions';
import VscodeActions from '../application/actions/VscodeActions';
import { FeatureFlagsActions } from '../featureFlags';
import type { ActionType } from './TypeHelper';

export const actions = {
  ...AchievementActions,
  ...LeaderboardActions,
  ...CommonsActions,
  ...CollabEditingActions,
  ...DashboardActions,
  ...InterpreterActions,
  ...PlaygroundActions,
  ...SessionActions,
  ...WorkspaceActions,
  ...GitHubActions,
  ...GroundControlActions,
  ...AcademyActions,
  ...PersistenceActions,
  ...RemoteExecutionActions,
  ...FileSystemActions,
  ...SideContentActions,
  ...VscodeActions,
  ...SideContentActions,
  ...FeatureFlagsActions,
  ...LanguageDirectoryActions,
  ...PluginDirectoryActions,
};

export type SourceActionType = ActionType<typeof actions>;
